import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {StorageService} from '@app/shared/storage.service';
import {Observable} from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private storageService: StorageService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const authRequest = this.addTokenHeader(request);
        return next.handle(authRequest);
    }

    addTokenHeader(request: HttpRequest<any>): HttpRequest<any> {
        const token = this.storageService.get('token');
        const provider = this.storageService.get('provider');
        if (token && provider) {
            const cloned = request.clone({
                headers: request.headers.set('Authorization', `Bearer ${provider} ${token}`),
            });

            return cloned;
        }
        return request;
    }
}
